import { render, staticRenderFns } from "./Orderdetails.vue?vue&type=template&id=8905ce30&scoped=true&"
import script from "./Orderdetails.vue?vue&type=script&lang=js&"
export * from "./Orderdetails.vue?vue&type=script&lang=js&"
import style0 from "./Orderdetails.vue?vue&type=style&index=0&id=8905ce30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8905ce30",
  null
  
)

export default component.exports